import { render, staticRenderFns } from "./ReductionMonitoring.vue?vue&type=template&id=77e81236"
import script from "./ReductionMonitoring.vue?vue&type=script&lang=js"
export * from "./ReductionMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports